import {Layout} from "antd";
import styled from "styled-components";

export const { Content } = Layout;

export const RightSection : typeof Layout = styled(Layout)`
background-color: #E5E5E5
`